/* ============================================================
   Wrinkle Gods — Online Store 2.0 theme interactions
   Ported from the UI-kit's kit.js. All the cosmetic behaviour
   (marquees, reveals, sticky header, parallax, accordions,
   gallery, mobile menu) is unchanged; the FAKE add-to-cart is
   replaced with the real Shopify AJAX Cart API.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Money formatting (uses theme money format) ---------- */
  var MONEY_FORMAT = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  ready(function () {
    if (window.lucide) window.lucide.createIcons();

    /* ---- Marquees ---- */
    function fillMarquees() {
      document.querySelectorAll('.announce__track, .marquee__track').forEach(function (track) {
        if (!track.dataset.seed) track.dataset.seed = track.innerHTML;
        var seed = track.dataset.seed;
        track.innerHTML = seed;
        var seedW = track.scrollWidth || 1;
        var containerW = (track.parentElement ? track.parentElement.clientWidth : window.innerWidth) || window.innerWidth;
        var copies = Math.max(1, Math.ceil(containerW / seedW) + 1);
        var half = '';
        for (var i = 0; i < copies; i++) half += seed;
        track.innerHTML = half + half;
        var halfW = seedW * copies;
        track.style.animationDuration = Math.round(halfW / 70) + 's';
      });
    }
    fillMarquees();
    var mqT;
    window.addEventListener('resize', function () { clearTimeout(mqT); mqT = setTimeout(fillMarquees, 200); });

    /* ---- Sticky header + parallax ---- */
    var header = document.querySelector('.site-header');
    var heroDark = document.querySelector('[data-header-dark]');
    function onScroll() {
      var y = window.scrollY;
      if (header) header.setAttribute('data-scrolled', y > 20 ? 'true' : 'false');
      if (header && heroDark) {
        if (y > heroDark.offsetHeight - 120) header.classList.remove('is-dark');
        else header.classList.add('is-dark');
      }
      document.querySelectorAll('[data-parallax]').forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-center * speed) + 'px,0)';
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---- Scroll reveals ---- */
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reveals = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (prefersReduced || designMode || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      document.documentElement.classList.add('wg-anim');
      var revealNow = function (el) { el.classList.add('in'); };
      var inView = function (el) {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        return r.top < vh * 0.95 && r.bottom > 0;
      };
      var firstPass = function () { reveals.forEach(function (el) { if (!el.classList.contains('in') && inView(el)) revealNow(el); }); };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { revealNow(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      requestAnimationFrame(firstPass);
      window.addEventListener('load', firstPass);
      setTimeout(firstPass, 250);
      setTimeout(function () { reveals.forEach(revealNow); }, 2600);
    }

    /* ---- Cart drawer open/close ---- */
    var overlay = document.querySelector('.drawer-overlay');
    var drawer = document.querySelector('.drawer');
    function openCart() { if (overlay && drawer) { overlay.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; } }
    function closeCart() { if (overlay && drawer) { overlay.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow = ''; } }
    document.querySelectorAll('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
    document.querySelectorAll('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
    if (overlay) overlay.addEventListener('click', closeCart);

    /* ========================================================
       REAL Shopify cart — AJAX Cart API
       ======================================================== */
    var countEls = document.querySelectorAll('[data-cart-count]');
    function setCount(n) { countEls.forEach(function (c) { c.textContent = n; }); }

    function renderDrawer(cart) {
      var body = drawer && drawer.querySelector('.drawer__body');
      var totalEl = drawer && drawer.querySelector('[data-cart-total]');
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<p style="padding:40px 4px;color:var(--color-text-muted);font-family:var(--font-sans)">Your ritual is empty.</p>';
        } else {
          body.innerHTML = cart.items.map(function (it) {
            return '<div class="cart-line">' +
              '<div class="cart-line__img"><img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : '') + '" alt=""></div>' +
              '<div><div class="cart-line__name">' + it.product_title + '</div>' +
              '<div class="cart-line__meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : (it.product_type || '')) + '</div>' +
              '<div class="qty" data-line-key="' + it.key + '"><button data-qty="down">–</button><span data-qty-val>' + it.quantity + '</span><button data-qty="up">+</button></div></div>' +
              '<div class="cart-line__price">' + formatMoney(it.final_line_price) + '</div></div>';
          }).join('');
          bindDrawerQty();
        }
      }
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      setCount(cart.item_count);
    }

    function refreshCart(open) {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderDrawer(cart); if (open) openCart(); return cart; });
    }

    function changeLine(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); return cart; });
    }

    function bindDrawerQty() {
      drawer.querySelectorAll('.qty[data-line-key]').forEach(function (q) {
        var key = q.getAttribute('data-line-key');
        var val = q.querySelector('[data-qty-val]');
        q.querySelectorAll('[data-qty]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var n = parseInt(val.textContent, 10) || 1;
            n += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
            if (n < 0) n = 0;
            changeLine(key, n);
          });
        });
      });
    }

    /* Add to cart: works on a <form action="/cart/add"> OR a button with data-variant-id */
    function addVariant(variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { return refreshCart(true); });
    }

    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCart(true); })
          .catch(function () { form.submit(); });
      });
    });

    document.querySelectorAll('[data-add-to-cart][data-variant-id]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        addVariant(b.getAttribute('data-variant-id'), parseInt(b.getAttribute('data-qty-add') || '1', 10));
      });
    });

    /* keep drawer in sync on load (server already rendered it, but counts may be cached) */
    if (drawer) refreshCart(false);

    /* ---- Mobile menu ---- */
    var mobile = document.querySelector('.mobile-menu');
    document.querySelectorAll('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { if (mobile) { mobile.classList.add('open'); document.body.style.overflow = 'hidden'; } }); });
    document.querySelectorAll('[data-close-menu]').forEach(function (b) { b.addEventListener('click', function () { if (mobile) { mobile.classList.remove('open'); document.body.style.overflow = ''; } }); });

    /* ---- Accordion ---- */
    function bindAccordions(root) {
      (root || document).querySelectorAll('[data-accordion] .acc-item').forEach(function (item) {
        if (item.dataset.accBound) return; item.dataset.accBound = '1';
        var head = item.querySelector('.acc-head');
        if (head) head.addEventListener('click', function () {
          var open = item.classList.contains('open');
          var parent = item.closest('[data-accordion]');
          if (parent && !parent.hasAttribute('data-multi')) parent.querySelectorAll('.acc-item.open').forEach(function (o) { if (o !== item) o.classList.remove('open'); });
          item.classList.toggle('open', !open);
        });
      });
    }
    bindAccordions(document);

    /* ---- Product gallery thumbs ---- */
    function bindGalleries(root) {
      (root || document).querySelectorAll('[data-gallery]').forEach(function (g) {
        if (g.dataset.galBound) return; g.dataset.galBound = '1';
        var main = g.querySelector('[data-gallery-main]');
        g.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.addEventListener('click', function () {
            if (main) { main.src = t.getAttribute('data-thumb'); main.classList.toggle('is-scene', t.hasAttribute('data-scene')); }
            g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
            t.classList.add('active');
          });
        });
      });
    }
    bindGalleries(document);

    /* ---- Made-with-care: mobile feature rotator (slideshow) ---- */
    function bindRotators(root) {
      (root || document).querySelectorAll('[data-made-rotator]').forEach(function (rot) {
        if (rot.dataset.rotBound) return; rot.dataset.rotBound = '1';
        var items = rot.querySelectorAll('.made__rotate-item');
        if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
        var i = 0; items[0].classList.add('is-active');
        if (prefersReduced) return;
        setInterval(function () {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, 3200);
      });
    }
    bindRotators(document);

    /* ---- Shopify theme editor: re-init a section when it is re-rendered ----
       Without this, edited sections lose their icons/accordions and (because the
       scroll-reveal CSS hides .reveal until observed) can appear blank while editing. */
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target;
      if (window.lucide) window.lucide.createIcons();
      if (sec && sec.querySelectorAll) sec.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      bindAccordions(sec);
      bindGalleries(sec);
      bindRotators(sec);
      fillMarquees();
    });
  });
})();
